import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format kode akses untuk dibaca: "-" tiap 4 digit (3757436527 → 3757-4365-27).
 * Hanya untuk tampilan — copy tetap pakai digit mentah.
 */
export function formatAccessCode(code) {
  if (!code || !/^\d{8,}$/.test(code)) return code;
  return code.replace(/(\d{4})(?=\d)/g, "$1-");
}
